import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { CancelComponent } from './Appointment/cancel/cancel.component';
import { RescheduleComponent } from './Appointment/reschedule/reschedule.component';
import { SignupComponent } from './signup/signup.component';
import { VolunteerComponent } from './volunteer/volunteer.component';
import { SelfAssistComponent } from './self-assist/self-assist.component';
import { ManagementComponent } from './management/management.component';
import { AppointmentComponent } from './management/appointment/appointment.component';
import { UserComponent } from './management/user/user.component';
import { QueueComponent } from './queue/queue.component';
import { SiteComponent } from './management/site/site.component';
import { RegisterComponent } from './login/register/register.component';
import { ProfileComponent } from './Staff/profile/profile.component';
import { QuestionnaireComponent } from './questionnaire/questionnaire.component';

const unlTag = "| TCAN / VITA | University of Nebraska\u2013Lincoln";
export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    title: "TCAN / VITA | University of Nebraska\u2013Lincoln"
  },
  {
    path: 'login',
    component: LoginComponent,
    title: "Login "+unlTag
  },
  {
    path: 'questionnaire',
    component: QuestionnaireComponent,
    title: "Questionnaire "+unlTag
  },
  {
    path: 'profile',
    component: ProfileComponent,
    title: "Profile "+unlTag
  },
  {
    path: 'appointment/cancel',
    component: CancelComponent,
    title: "Cancel Appointment "+unlTag
  },
  {
    path: 'appointment/reschedule',
    component: RescheduleComponent,
    title: "Cancel or Reschedule Appointment "+unlTag
  },
  {
    path: 'signup',
    component: SignupComponent,
    title: "Sign Up for a VITA Appointment "+unlTag
  },
  {
    path: 'volunteer',
    component: VolunteerComponent,
    title: "Staff "+unlTag
  },
  {
    path: 'self_assist',
    component: SelfAssistComponent,
    title: "Facilitated Self-Assistance "+unlTag
  },
  {
    path: 'management',
    component: ManagementComponent,
    title: "Management "+unlTag
  },
  {
    path: 'management/appointments/:appointmentId',
    component: AppointmentComponent,
    title: "Manage Appointments "+unlTag
  },
  {
    path: 'management/appointments',
    component: AppointmentComponent,
    title: "Manage Appointments "+unlTag
  },
  {
    path: 'management/users',
    component: UserComponent,
    title: "Manage Users "+unlTag
  },
  {
    path: 'management/sites',
    component: SiteComponent,
    title: "Manage Sites "+unlTag
  },
  {
    path: 'queue',
    component: QueueComponent,
    title: "Queue "+unlTag
  },
  {
    path: 'register',
    component: RegisterComponent,
    title: "Register "+unlTag
  },
];
